
import { defineComponent } from 'vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default defineComponent({
    name: 'TelaCkEditor',
    data() {
        return {
            classicEditor: ClassicEditor,
            editorHtml: '',
        };
    },
});
